export default __webpack_public_path__ + "static/media/5R.1cdf87eb.png";